import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { fetchDomainCoverageIfNeeded } from '../../actions/policy-progress-action-creators';
import {
    reportHeaderSelector,
    selectedDomainTypeSelector,
    selectedEndDateSelector,
    selectedIntervalSelector,
    selectedStartDateSelector
} from '../../selectors/reports-selectors';
import DomainCoverageProgressBulletsContainer from
    './domain-coverage-progress-bullets-container';
import DomainCoverageProgressStatementContainer from
    './domain-coverage-progress-statement-container';
import ReportingCard from '../../components/reporting-card';

export class DomainCoverageSectionContainer extends Component{
    componentDidMount(){
        const { onInitialLoad, fetchDomainCoverageIfNeeded } = this.props;

        onInitialLoad();
        fetchDomainCoverageIfNeeded();
    }

    componentDidUpdate(){
        const { fetchDomainCoverageIfNeeded } = this.props;

        fetchDomainCoverageIfNeeded();
    }

    render(){
        const { header } = this.props;

        return (
            <ReportingCard
                header={ header }
                dataIsLoading={ false }
                allowDownload={ false }
                type={ 'domainCoverage' }
                order={ 1 }
                content={{
                    footer: '* p=reject or p=quarantine policies',
                    leftContent: <DomainCoverageProgressBulletsContainer />,
                    rightContent: <DomainCoverageProgressStatementContainer />,
                    table: false,
                    textheader: 'How many of our domains have (DMARC) blocking* policies to prevent unauthorized, outbound email?',
                    title: 'Summary',
                }}
            />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        header: reportHeaderSelector( state ),
        selectedDomainType: selectedDomainTypeSelector( state ),
        selectedEndDate: selectedEndDateSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
        selectedStartDate: selectedStartDateSelector( state ),
    };
};

DomainCoverageSectionContainer.propTypes = {
    fetchDomainCoverageIfNeeded: PropTypes.func.isRequired,
    header: PropTypes.object.isRequired,
    onInitialLoad: PropTypes.func.isRequired,
    selectedDomainType: PropTypes.string,
    selectedEndDate: PropTypes.string.isRequired,
    selectedInterval: PropTypes.string,
    selectedStartDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { fetchDomainCoverageIfNeeded } )( DomainCoverageSectionContainer );
